import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, delay, map, takeUntil, tap } from 'rxjs/operators';
import { ConfirmDailogueComponent } from 'src/app/shared/components/dailogue/confirm-dailogue.component';
import { DeactivateComponent } from 'src/app/shared/components/deactivate/deactivate.component';
import { ReactivateComponent } from 'src/app/shared/components/reactivate/reactivate.component';
import { Api } from 'src/app/shared/constants/api';
import { APP_ROUTES } from 'src/app/shared/constants/approutes';
import { Message } from 'src/app/shared/constants/message';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from "underscore";
import { IContainer } from '../container.interface';

@Component({
    selector: 'app-container-form',
    templateUrl: './container-form.component.html',
    styleUrls: ['./container-form.component.less'],
    standalone: false
})
export class ContainerFormComponent implements OnInit {

  constructor(private formBuilder:FormBuilder,private router:Router,
              private activatedRoute:ActivatedRoute,private logger:NGXLogger,
              private service:DataService, private dailog: MatDialog, private utilityService:UtilityService,
              private permissionService:PermissionService) { }

  containerForm:FormGroup;
  equipmentSizes:any;
  equipmentTypes:any;
  equipmentTypeById:any;
  equipmentSizeById:any;
  status:string;
  showDeactivateToggle:boolean=false;
  showReactivateToggle:boolean=false;
  checked:boolean=false;
  reactivatePermission:boolean=false;
  deactivatePermission:boolean=false;
  searching:boolean=false;
  containerSearchCtrl=this.formBuilder.control('');
  equipmentSearchCtrl=this.formBuilder.control('');
  editPermission:boolean=false;
  addPermission:boolean = false;
  onDestroy = new Subject<void>();
  filteredContainer:ReplaySubject<IContainer[]> = new ReplaySubject<IContainer[]>(1);
  filteredEquipment:ReplaySubject<IContainer[]> = new ReplaySubject<IContainer[]>(1);
  isEditedData:boolean
  copyCartingEntryColumns=['code','name'];

  ngOnInit(): void {
    this.checkAllPermission();
    this.initializeForm();
    this.getEquipmentSizes();
    this.getEquipmentTypes();
    this.filterContainer();
    this.filterEquipment();
    this.setEquipmentSizeValueChangeEvent();
    this.setEquipmentTypeValueChangeEvent();
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        if(+param['id'])
          this.id.setValue(+param['id']);
    });
    this.getContainerById();
  }

  initializeForm(){
    this.containerForm=this.formBuilder.group({
       id:[],
       deactivate:[],
       equipmentTypeId:[null,[Validators.required]],
       sizeId:[null,[Validators.required]],
       name:[null],
       reactivate:[],
       noOfTeu:[null],
       specialEquipment:[null],
       status:[null]
    });
  }

  setEquipmentSizeValueChangeEvent(){
    this.sizeId.valueChanges.subscribe(idValue => {
      this.equipmentSizeById = _.findWhere(this.equipmentSizes,{id:idValue});
      if(this.equipmentSizeById){
         this.noOfTeu.setValue(this.equipmentSizeById.noOfTeu);
         this.name.reset();
         this.setContainerName();
      }
    })
  }

  setEquipmentTypeValueChangeEvent(){
    this.equipmentTypeId.valueChanges.subscribe(idValue => {
      this.equipmentTypeById = _.findWhere(this.equipmentTypes,{id:idValue});
      if(this.equipmentTypeById){
         this.specialEquipment.setValue(this.equipmentTypeById.type);
         this.name.reset();
         this.setContainerName();
      }
    })
  }

  getEquipmentTypeCode(equipmentId:number){
    if(equipmentId){
       let equipment=_.findWhere(this.equipmentTypes,{id:equipmentId});
       return equipment?equipment.code:null;
    }
  }

  onSave(){
    this.setContainerName();
    this.containerForm.markAllAsTouched();
    if(this.containerForm.valid){
      this.isEditedData=true;
      if(this.id.value){
        this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
      }
      else {
        this.openDailog(Message.SAVE_OPEN_DAILOG);
      }      
   }
  }  

  saveContainer(){
    let method = (this.id.value) ? 'put' : 'post';
    let message=(this.id.value)?'updated':'saved';
    if(this.containerForm.valid){
      this.service[method](Api.CONTAINER, this.containerForm.value).subscribe(res => {
        this.utilityService.notifier('Container Details '+ message + ' successfully', 'success');
        this.router.navigate([APP_ROUTES.CONTAINER_LIST]);
      });
    }
  }

  private setContainerName(){
    if(this.equipmentTypeById && this.equipmentSizeById){
      this.name.setValue(this.equipmentSizeById.size+" "+this.equipmentTypeById.code);
    }
  }

  openDeactivateForm(){
    let data={id:this.contId.value,route:APP_ROUTES.CONTAINER_LIST,message:'Container',api:Api.CONTAINER_DEACTIVATE,
                isReasonMandatory:false};
    const dailogRef=this.dailog.open(DeactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
      
    })    
  }

  openReactivateForm(){
    let data={id:this.contId.value,route:APP_ROUTES.CONTAINER_LIST,message:'Container',api:Api.CONTAINER_REACTIVATE,
              isReasonMandatory:false};
    const dailogRef=this.dailog.open(ReactivateComponent,{data:data});
    dailogRef.afterClosed().subscribe(value => {
      this.checked = !this.checked;
      
    })    
  }

  onCancel(){
    if(this.containerForm.dirty){
      this.isEditedData=false;
      this.id.value ? this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT):
          this.openDailog(Message.CANCEL_OPEN_DAILOG);
    }else{
      this.router.navigate([APP_ROUTES.CONTAINER_LIST]);
    }
  }

  openDailog(message?:string)
  {
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });

    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else {
          if(!this.isEditedData) {
            this.router.navigate([APP_ROUTES.CONTAINER_LIST]);
          }
          else {
            //this.saveDestination();
            this.saveContainer();
          }
        }
    })
  }

  getContainerById(){
    if(this.contId.value){
      this.service.get(Api.CONTAINER+'/'+this.contId.value).subscribe(res => {
         if(res){
           this.containerForm.patchValue(res);
           //this.containerForm.disable();
           this.status=this.getStatus(res);
         }
      });
    }
  }

  private getStatus(data: any) {
    if (data.status == "APPROVED" && !data.submittedForApproval) {
      if(this.deactivatePermission){
        this.showDeactivateToggle=true;
      }
      return null;
    }
    else if (data.status == "DEACTIVATED" && !data.submittedForApproval) {
      if(this.reactivatePermission){
        this.showReactivateToggle=true;
        this.containerForm.disable();
      }
      return "Deactivated...";
    } else {
      return this.utilityService.getApprovalMessage({status:data.status,
        submittedForApproval: data.submittedForApproval,
        deactivationWefDate: data.deactivate?.deactivationWefDate,
        reactivationWefDate: data.reactivate?.reactivationWefDate});
    }
  }

  getEquipmentSizes(){
    this.service.get(Api.EQUIPMENT_SIZES_FOR_DD).subscribe(res => {
      this.equipmentSizes=res;
      this.filteredContainer.next(this.equipmentSizes);
    });
  }

  filterContainer(){
    this.containerSearchCtrl.valueChanges.pipe(
      tap(() => this.searching = true),
      takeUntil(this.onDestroy),
      debounceTime(200),
      map(search => {
        if (!this.equipmentSizes) { return []; }
        if(!search) { this.filteredContainer.next(this.equipmentSizes); }
        return this.equipmentSizes.filter(container => container.size.indexOf(search) > -1);
      }),
      delay(200)
    )
    .subscribe(filtered => {
      this.searching = false;
      this.filteredContainer.next(filtered);
    },
    error => { this.searching = false; });
  }

  getEquipmentTypes(){
    this.service.get(Api.EQUIPMENT_TYPES_FOR_DD).subscribe(res => {
      this.equipmentTypes=res;
      this.filteredEquipment.next(this.equipmentTypes);
    });
  }

  filterEquipment(){
    this.equipmentSearchCtrl.valueChanges.pipe(
      tap(() => this.searching = true),
      takeUntil(this.onDestroy),
      debounceTime(200),
      map(search => {
        if (!this.equipmentTypes) { return []; }
        if(!search) { this.filteredEquipment.next(this.equipmentTypes); }
        return this.equipmentTypes.filter(container => container.code.toLowerCase().indexOf(search) > -1);
      }),
      delay(200)
    )
    .subscribe(filtered => {
      this.searching = false;
      this.filteredEquipment.next(filtered);
    },
    error => { this.searching = false; });
  }

  public checkAllPermission(){
    let permissionCodes=[PermissionKey.CONTAINER_MODULE_REACTIVATE_PERMISSION,PermissionKey.CONTAINER_MODULE_DEACTIVATE_PERMISSION,
                         PermissionKey.CONTAINER_MODULE_EDIT_PERMISSION,PermissionKey.CONTAINER_MODULE_ADD_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.CONTAINER_MODULE);
    this.reactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CONTAINER_MODULE_REACTIVATE_PERMISSION})?.show?true:false;
    this.deactivatePermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CONTAINER_MODULE_DEACTIVATE_PERMISSION})?.show?true:false;
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CONTAINER_MODULE_EDIT_PERMISSION})?.show?true:false;
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.CONTAINER_MODULE_ADD_PERMISSION})?.show?true:false;
  }

  get sizeId(){ return this.containerForm.get('sizeId') };
  get equipmentTypeId(){ return this.containerForm.get('equipmentTypeId') };
  get name(){ return this.containerForm.get('name') };
  get noOfTeu(){ return this.containerForm.get('noOfTeu') };
  get specialEquipment(){ return this.containerForm.get('specialEquipment') };
  get id(){return this.containerForm.get('id') };
  get contId(){return this.containerForm.get('id'); };
}
